export default {
  // Általános
  skip: 'Kihagyás',
  back: 'Vissza',
  next: 'Következő',
  finish: 'Befejezés',
  close: 'Bezárás',
  
  // Welcome
  welcome: {
    title: 'Üdvözlünk a YouCRM-ben! 🎉',
    subtitle: 'Szeretnéd, hogy körbevezetünk az alkalmazásban?',
    start: 'Igen, indítsuk!',
    skipAll: 'Kihagyom',
    description: 'Néhány perc alatt megmutatjuk a főbb funkciókat.'
  },
  
  // Dashboard Tour
  dashboard: {
    title: 'Dashboard Körbevezetés',
    steps: {
      welcome: {
        title: '📊 Dashboard',
        content: 'Ez a főoldal, ahol áttekintést kapsz a legfontosabb adatokról és statisztikákról.'
      },
      stats: {
        title: '📈 Statisztikák',
        content: 'Itt láthatod az ügyfelek, projektek és feladatok összesítését valós időben.'
      },
      quickActions: {
        title: '⚡ Gyors Műveletek',
        content: 'Gyakran használt funkciók gyors elérése egy kattintással.'
      },
      recentActivity: {
        title: '🕐 Legutóbbi Tevékenységek',
        content: 'Kövesd nyomon a legfrissebb eseményeket és változásokat.'
      }
    }
  },
  
  // Flow Builder Tour
  flowBuilder: {
    title: 'Flow Builder Körbevezetés',
    steps: {
      welcome: {
        title: '🎨 Flow Builder',
        content: 'Vizuális automatizálási eszköz, ahol kódolás nélkül építhetsz komplex munkafolyamatokat.'
      },
      canvas: {
        title: '🖼️ Canvas',
        content: 'Itt építheted a flow-kat drag & drop módszerrel. Húzd át a node-okat és kösd össze őket!'
      },
      sidebar: {
        title: '🧩 Node Paletta',
        content: 'Húzd át a node-okat a canvas-ra. Kategóriák szerint rendezve: Trigger, Action, Logic, stb.'
      },
      properties: {
        title: '⚙️ Tulajdonságok',
        content: 'Kattints egy node-ra a részletes beállításokhoz. Itt konfigurálhatod a működését.'
      },
      toolbar: {
        title: '🛠️ Eszköztár',
        content: 'Mentés, futtatás, ütemezés és egyéb műveletek. A ⚡ gombbal futtathatod a flow-t!'
      },
      terminal: {
        title: '📟 Terminál',
        content: 'Valós idejű végrehajtási logok. Kövesd nyomon, mi történik a flow futása közben.'
      }
    }
  },
  
  // Customers Tour
  customers: {
    title: 'Ügyfelek Körbevezetés',
    steps: {
      welcome: {
        title: '👥 Ügyfélkezelés',
        content: 'Kezeld az ügyfeleidet, kapcsolattartókat és minden fontos információt egy helyen.'
      },
      list: {
        title: '📋 Ügyféllista',
        content: 'Keress, szűrj és rendezz az ügyfelek között. Kattints egy sorra a részletekért.'
      },
      add: {
        title: '➕ Új Ügyfél',
        content: 'Adj hozzá új ügyfelet a + gombbal. Töltsd ki az alapvető adatokat és mentsd el.'
      },
      search: {
        title: '🔍 Keresés',
        content: 'Gyors keresés név, email vagy cégnév alapján. Valós időben szűr!'
      },
      filters: {
        title: '🎯 Szűrők',
        content: 'Szűrj státusz, címkék vagy egyéni mezők alapján. Kombinálhatod a szűrőket!'
      }
    }
  },
  
  // Help Button
  helpButton: {
    tooltip: 'Körbevezetés újraindítása',
    label: 'Súgó'
  },
  
  // Progress
  progress: {
    step: 'lépés',
    of: '/',
    completed: 'Körbevezetés befejezve! 🎉'
  }
};
